<div *ngIf="visible" class="spinner-backdrop">
  <div class="spinner"></div>
</div>
